import { en } from './en';
import { zh } from './zh';
import { nl } from './nl';

export const locales = {
  en,
  zh,
  nl,
};

export type LocaleType = keyof typeof locales;
export type TranslationType = typeof en;

export const getLocale = (locale: LocaleType): TranslationType => {
  return locales[locale] || en;
};

// 语言检测映射
export const languageMapping: Record<string, LocaleType> = {
  'zh': 'zh',
  'zh-CN': 'zh',
  'zh-TW': 'zh',
  'zh-HK': 'zh',
  'nl': 'nl',
  'nl-NL': 'nl',
  'nl-BE': 'nl',
  'en': 'en',
  'en-US': 'en',
  'en-GB': 'en',
  'en-CA': 'en',
  'en-AU': 'en',
};

// 获取用户首选语言
export const getUserPreferredLocale = (): LocaleType => {
  const browserLang = navigator.language || navigator.languages?.[0] || 'en';
  return languageMapping[browserLang] || 'en';
};

// 语言名称映射
export const languageNames: Record<LocaleType, string> = {
  en: 'English',
  zh: '中文',
  nl: 'Nederlands',
}; 